module.exports = __webpack_public_path__ + "static/img/source_2.080e2ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/module/dataIndex/static/source_2.png
// module id = w+wY
// module chunks = 60